/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { participationRatesGetApiV3ParticipationRates } from "../../funcs/participationRatesGetApiV3ParticipationRates.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3ParticipationRatesRequest$inboundSchema
    .optional(),
};

export const tool$participationRatesGetApiV3ParticipationRates: ToolDefinition<
  typeof args
> = {
  name: "participation-rates-get-api-v3-participation-rates",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] =
      await participationRatesGetApiV3ParticipationRates(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
